import { PayloadAction } from '@reduxjs/toolkit';

import { ReportsState } from '../../types';

import { Report } from 'entities/reports';

export const setUnauthorizedReportStatus = (
  state: ReportsState,
  action: PayloadAction<Report['state']>,
) => {
  state.unauthorizedReport.status = action.payload;
};
